import { useCallback, useState } from 'react';

export const useToggle = (
  initialState = false
): [boolean, () => void, () => void, () => void] => {
  const [state, setState] = useState<boolean>(initialState);
  const toggle = useCallback(() => setState((state) => !state), []);
  const close = useCallback(() => setState(false), []);
  const open = useCallback(() => setState(true), []);

  return [state, toggle, open, close];
};

export default useToggle;
